var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgRefreshActionBar = function SvgRefreshActionBar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    className: "refresh-action-bar-icon",
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.45218 15.3751C5.31749 16.6702 6.5474 17.6795 7.98637 18.2756C9.42534 18.8716 11.0087 19.0275 12.5363 18.7237C14.0639 18.4198 15.4671 17.6698 16.5685 16.5685C17.6698 15.4671 18.4198 14.0639 18.7237 12.5363C19.0275 11.0087 18.8716 9.42534 18.2756 7.98637C17.6795 6.5474 16.6702 5.31749 15.3751 4.45218C14.0801 3.58686 12.5575 3.125 11 3.125C8.79846 3.13328 6.68535 3.99232 5.1025 5.5225L3.125 7.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 3.125V7.5H7.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default __webpack_public_path__ + "assets/6d2c42445b484bebf2aaf1e63f4ac622.svg";
export { SvgRefreshActionBar as ReactComponent };


// WEBPACK FOOTER //
// ./assets/icons/refresh-action-bar.svg